import React, { memo } from 'react'
import styles from '../styles.module.scss'
import { getItemSizeClass } from '../hooks/utils'
import FlowerItem from './FlowerItem'

interface FlowerGridProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  flowers: any[]
  selectedFlowers: Set<number>
  onFlowerSelect: (index: number) => void
}

/* eslint-disable react/prop-types */
const FlowerGrid = memo<FlowerGridProps>(({ flowers, selectedFlowers, onFlowerSelect }) => (
  <div className={styles.masonryGrid} role="grid" aria-label="Flower selection grid">
    {flowers.map((flower, index) => (
      <FlowerItem
        key={`flower-${index}`}
        flower={flower}
        index={index}
        isSelected={selectedFlowers.has(index)}
        sizeClass={getItemSizeClass(index)}
        onSelect={onFlowerSelect}
      />
    ))}
  </div>
))

FlowerGrid.displayName = 'FlowerGrid'

export default FlowerGrid
